import { BaseForm, DestroyForm }  from './form_mixin';
import serializeJSON from 'utilities/serialize_json';
import qs            from 'qs';
import { START_DRAGGING, END_DRAGGING } from 'apps/events';
import { destroy }   from 'apps/actions/common';
import watch from "redux-watch";
import isEqual from 'is-equal';
import { newDataFromDot } from 'utilities/hash';
import { TAG_UPDATED, AJAX_ACCECCED, AJAX_ACCECCING } from 'apps/events';
import { api }     from 'apps/api';

export class BaseAjaxForm extends BaseForm {
  init(){
    super.init();
    this.watchSaved();
  }
  protected watchSaved(){
    let scope = this.fullScope() + '.updated_at';
    let callback = this.onSaved;
    let w = watch(App.store.getState, scope, isEqual);
    let unsubscribe =  App.store.subscribe(w((newVal, oldVal, objectPath) => {
      callback(newVal, oldVal, objectPath);
    }));
    this.on('unmount', () => { unsubscribe(); })
    return unsubscribe
  }
  protected onSaved(newVal: any, oldVal: any, objectPath: string){
    let e = new CustomEvent(AJAX_ACCECCED, {detail: this.tagScope});
    document.dispatchEvent(e);
  }
  protected saveParams(){
    let payload = {};
    if(this.opts.inputs.authenticity_token){
      payload["at"] = this.opts.inputs.authenticity_token.value;
    }
    let fe = this.formElement();
    payload['params'] = serializeJSON(fe);
    payload['url'] = fe.getAttribute('action');
    let method_input = fe.querySelector('[name="_method"]')
    if(method_input){
      payload['method'] = method_input.getAttribute('value');
    } else {
      payload['method'] = fe.getAttribute('method');
    }
    payload['scope'] = this.tagScope;
    return payload;
  }

  protected submit(){
    let e = new CustomEvent(AJAX_ACCECCING, {detail: this.tagScope});
    document.dispatchEvent(e);
    App.store.dispatch(this.submitFunction(this.saveParams()))
  }
}

export class DestroyAjaxForm extends BaseAjaxForm {
  submitFunction = destroy;
  isShow: boolean;
  public init(){
    super.init();
    this.isShow = false;
  }
  protected onClickDestroy(){
    this.isShow = true;
    this.update();
  }
  protected destroyParams(){
    let payload = { at: App.authenticity_token() }
    let fe = this.formElement();
    payload['url']   = fe.getAttribute('action');
    payload['scope'] = this.tagScope;
    payload['params'] = serializeJSON(fe);
    return payload
  }
  protected submit(){
    App.store.dispatch(this.submitFunction(this.destroyParams()))
  }
}

// export class PositionForm extends BaseAjaxForm {
//   init(){
//     super.init();
//     document.addEventListener(START_DRAGGING, ()=>{ this.onStartDrag() });
//     document.addEventListener(END_DRAGGING,   ()=>{ this.onEndDrag() });
//   }
//   private onStartDrag(){
//     this.disableAll();
//   }
//   private onEndDrag(){
//     this.enableAll();
//   }
//   protected submit(){
//     App.store.dispatch(this.submitFunction(this.saveParams()))
//   }
// }
riot.mixin('forms.destroy', DestroyAjaxForm as riot.TagMixin);
